import { useEffect } from "react";

interface OutputViewProps {
  isVisible: boolean;
  isResizing: boolean;
}

const OutputView: React.FC<OutputViewProps> = ({ isVisible }) => {
  /**
   * Observer to send the py-errors into the console
   */
  useEffect(() => {
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (
            node instanceof HTMLElement &&
            node.classList.contains("py-error")
          ) {
            const errorText = node.innerText.trim();
            if (errorText) {
              window.postMessage(
                {
                  type: "IFRAME_CONSOLE",
                  method: "error",
                  args: [errorText],
                },
                "*",
              );
            }
            node.remove();
          }
        }
      }
    });

    observer.observe(document.body, { childList: true });
    return () => observer.disconnect();
  }, []);

  return (
    <div
      className={`${
        isVisible ? "w-full h-full p-4 pt-0" : "w-0 h-0 p-0 invisible"
      } flex-1 flex flex-col rounded-xl`}
    >
      <div id="code-output" className="h-full" />
    </div>
  );
};

export default OutputView;
